import {
  GENERATION_TOOL,
  type GenerationTool,
  isBasicContentImproverTool,
} from 'src/data/generationTool';

import { AI_RECOMPOSE_MODE, type AiRecomposeMode } from './const';

const AI_RECOMPOSE_MODE_LABEL: Record<string, string> = {
  [AI_RECOMPOSE_MODE.relaxed]: 'Improve score',
  [AI_RECOMPOSE_MODE.strict]: 'Improve score, but keep structure',
  [AI_RECOMPOSE_MODE.tov]: 'Change tone of voice',
  [AI_RECOMPOSE_MODE.translate]: 'Translate',
  [AI_RECOMPOSE_MODE.keepAsIs]: 'Keep as is',
};

const AI_RECOMPOSE_MODE_DESCRIPTION: Record<string, string> = {
  [AI_RECOMPOSE_MODE.relaxed]: 'Make more engaging',
  [AI_RECOMPOSE_MODE.strict]: 'Fix spelling & grammar, replace a word where necessary',
};

export const getRecomposeModeLabel = (
  mode: AiRecomposeMode,
  generationTool?: GenerationTool
): string => {
  if (generationTool) {
    if (generationTool === GENERATION_TOOL.generalProductListing) {
      return 'Paragraph';
    }

    if (isBasicContentImproverTool(generationTool)) {
      if (mode === AI_RECOMPOSE_MODE.polished) {
        return 'Keep similar to original';
      }

      if (mode === AI_RECOMPOSE_MODE.relaxed) {
        return 'Improve';
      }

      if (mode === AI_RECOMPOSE_MODE.strict) {
        return 'Improve but keep structure';
      }
    }
  }

  return AI_RECOMPOSE_MODE_LABEL[mode] || '';
};

export const getRecomposeModeDescription = (
  mode: AiRecomposeMode,
  generationTool?: GenerationTool
) => {
  if (generationTool) {
    if (generationTool === GENERATION_TOOL.generalProductListing) {
      return '';
    }

    if (isBasicContentImproverTool(generationTool)) {
      if (mode === AI_RECOMPOSE_MODE.polished) {
        return 'Fix spelling & grammar, replace a word where necessary';
      }
      if (mode === AI_RECOMPOSE_MODE.relaxed) {
        return 'Write in a more engaging way';
      }
    }
  }

  return AI_RECOMPOSE_MODE_DESCRIPTION[mode] || '';
};

export const isRecomposeMode = (mode: string): mode is AiRecomposeMode =>
  Object.values(AI_RECOMPOSE_MODE).includes(mode as AiRecomposeMode);

export const isImproveRecomposeMode = (mode: AiRecomposeMode) => {
  const list: AiRecomposeMode[] = [AI_RECOMPOSE_MODE.relaxed, AI_RECOMPOSE_MODE.strict];
  return list.includes(mode);
};
